import { Box, styled, Theme } from '@material-ui/core';

export const CopyAndShareContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: '10px',
  fontSize: 16,
  alignItems: 'center',
  justifyContent: 'end',
  [theme.breakpoints.up('md')]: {
    justifyContent: 'start',
  },
}));
